$(function () {
  let map,
    allMarkers = [],
    bounds,
    infoWindow

  // Builds a DOM element to use as an AdvancedMarkerElement's custom content
  // (AdvancedMarkerElement needs its own DOM node per marker - unlike the
  // deprecated Marker's `icon`, this cannot be a shared/reused object).
  function sm_buildMarkerContent(iconUrl) {
    if (!iconUrl) {
      return undefined
    }

    let img = document.createElement('img')
    img.src = iconUrl
    img.className = 'a-institution-marker'

    return img
  }

  async function sm_initMap() {
    // Load the "maps" and "marker" libraries (google.maps.Map and
    // google.maps.marker.AdvancedMarkerElement) before using them.
    await google.maps.importLibrary('maps')
    await google.maps.importLibrary('marker')

    map = new google.maps.Map(document.getElementById('js-institutions-map'), {
      minZoom: 5,
      maxZoom: 15,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      // Advanced Markers require a Map ID. Note: a Map ID takes styling from
      // Google Cloud Console (Map Styles) instead of an inline `styles` array,
      // so the POI/road-label hiding previously configured here must be
      // recreated as a Cloud-based map style associated with this Map ID.
      mapId: gmap_map_id || undefined,
    })

    infoWindow = new google.maps.InfoWindow({
      disableAutoPan: false,
      maxWidth: window.matchMedia('(min-width: 767px)').matches ? 300 : 200,
    })

    // Load data from JSON file to markers array and set initial map data
    sm_setDefault(map)
  }

  function sm_setDefault(map) {
    $.get(
      ajax_script.uploadsdir + '/institutions.json',
      null,
      function (response) {
        $.each(response, function (index, institution) {
          // Add Main Campus
          let mainLatLng = new google.maps.LatLng(
            institution['main']['lat'],
            institution['main']['lng'],
          )

          if (mainLatLng) {
            let duplicate_marker = false

            if (allMarkers.length > 0) {
              for (var n = 0; n < allMarkers.length; n++) {
                if (mainLatLng.equals(allMarkers[n].position)) {
                  duplicate_marker = true

                  break
                }
              }
            }

            if (!duplicate_marker) {
              let marker = new google.maps.marker.AdvancedMarkerElement({
                position: mainLatLng,
                gmpClickable: true,
                content: sm_buildMarkerContent(institution['icon']),
              })

              marker.institutionName = institution['name']
              marker.institutionUrl = institution['url']
              marker.institutionLogo = institution['logo']
              marker.institutionIcon = institution['icon']
              marker.institutionId = institution['id']
              marker.isMainCampus = true
              marker.campusName = institution['main']['name']
              marker.campusAddress = institution['main']['address']
              marker.campusWebsite = institution['main']['website']
              marker.region = institution['main']['region']

              if (institution['other'] && institution['other'].length) {
                marker.hasMultiple = true
              } else {
                marker.hasMultiple = false
              }

              allMarkers.push(marker)
            }
          }

          // Add additional campuses
          if (institution['other'] && institution['other'].length) {
            $.each(institution['other'], function (index, campus) {
              let latLng = new google.maps.LatLng(campus['lat'], campus['lng'])

              if (latLng) {
                let duplicate_marker = false

                if (allMarkers.length > 0) {
                  for (var n = 0; n < allMarkers.length; n++) {
                    if (latLng.equals(allMarkers[n].position)) {
                      duplicate_marker = true
                      break
                    }
                  }
                }

                if (!duplicate_marker) {
                  let marker = new google.maps.marker.AdvancedMarkerElement({
                    position: latLng,
                    gmpClickable: true,
                    content: sm_buildMarkerContent(institution['icon']),
                  })

                  marker.institutionName = institution['name']
                  marker.institutionUrl = institution['url']
                  marker.institutionLogo = institution['logo']
                  marker.institutionIcon = institution['icon']
                  marker.institutionId = institution['id']
                  marker.isMainCampus = false
                  marker.campusName = campus['name']
                  marker.campusAddress = campus['address']
                  marker.campusWebsite = campus['website']
                  marker.region = campus['region']
                  marker.hasMultiple = true

                  allMarkers.push(marker)
                }
              }
            })
          }
        })

        // Show Main Campuses Intially
        bounds = new google.maps.LatLngBounds()

        $.each(allMarkers, function (index, marker) {
          if (marker.isMainCampus) {
            marker.map = map
            bounds.extend(marker.position)
          }
        })
        map.fitBounds(bounds, sm_boundsPadding())
        map.panToBounds(bounds)

        for (let i = 0; i < allMarkers.length; i++) {
          // AdvancedMarkerElement extends HTMLElement, so its "gmp-click"
          // event should be bound with addEventListener (not the deprecated
          // google.maps.event.addListener API). `this` still refers to the
          // marker since it's the element the listener is attached to.
          allMarkers[i].addEventListener('gmp-click', function () {
            infoWindow.close()
            let box = sm_buildInfoboxContent(this)

            infoWindow.setContent(box)
            infoWindow.open({ map, anchor: this })

            // map pan to center marker
            google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
              sm_AdjusMapPanForInfobox(map, this)
            })
          })
        }
      },
      'json',
    )
  }

  // Show Campuses by Institution ID
  function sm_showInstitutionCampuses(id = null) {
    sm_hideMarkers()
    bounds = new google.maps.LatLngBounds()

    $.each(allMarkers, function (index, marker) {
      if (marker.institutionId == id) {
        marker.map = map
        // Set Initial Bounds
        bounds.extend(marker.position)
      }
    })

    map.fitBounds(bounds, sm_boundsPadding())
    map.panToBounds(bounds)
  }

  function sm_showRegionInstitution(regionCode) {
    sm_hideMarkers()
    bounds = new google.maps.LatLngBounds()
    $.each(allMarkers, function (index, marker) {
      if (marker.isMainCampus) {
        if (regionCode === 'all') {
          marker.map = map
          bounds.extend(marker.position)
        } else if (marker.region === regionCode) {
          marker.map = map
          bounds.extend(marker.position)
        }
      }
    })

    map.fitBounds(bounds, sm_boundsPadding())
    map.panToBounds(bounds)
  }

  function sm_buildInfoboxContent(marker) {
    let box_content = '',
      box = document.createElement('div')

    box_content += '<div class="infoBox__wrap">'
    box_content +=
      '<button type="button" class="infoBox__close js-infobox-close" aria-label="Close">&times;</button>'
    box_content +=
      '<a target="_blank" href="' +
      marker.institutionUrl +
      '"><img src="' +
      marker.institutionLogo +
      '" onerror="this.onerror=null; this.src=\'' +
      marker.institutionIcon +
      '\'"></a>'

    // Campus Name
    if (marker.isMainCampus) {
      box_content +=
        '<h5><a target="_blank" href="' +
        marker.institutionUrl +
        '">' +
        marker.institutionName +
        '<br />'
      box_content += 'Main Campus - ' + marker.campusName + '</a></h5>'
    } else {
      box_content +=
        '<h5><a target="_blank" href="' +
        marker.institutionUrl +
        '">' +
        marker.campusName +
        ' Campus</a></h5>'
    }

    box_content += '<p>' + marker.campusAddress + '</p>'
    box_content += '<div class="flex-container">'
    if (marker.institutionUrl.length) {
      box_content += '<a target="_blank" href="' + marker.institutionUrl + '#campuses">info</a>'
    }
    if (marker.campusWebsite.length) {
      box_content += '<a target="_blank" href="' + marker.campusWebsite + '">website</a>'
    }
    if (marker.hasMultiple) {
      box_content +=
        '<a class="js-show-all-campuses" data-institution-id="' +
        marker.institutionId +
        '" href="#">campuses</a>'
    }
    box_content += '</div>'
    box_content += '</div>'

    box.innerHTML = box_content

    return box
  }

  // Sets the map on all markers in the array.
  function sm_setMapOnAll(map) {
    for (let i = 0; i < allMarkers.length; i++) {
      allMarkers[i].map = map
    }
  }

  // Removes the markers from the map, but keeps them in the array.
  function sm_hideMarkers() {
    sm_setMapOnAll(null)
    infoWindow.close()
  }

  function sm_showMarkers() {
    sm_setMapOnAll(map)
  }

  function sm_AdjusMapPanForInfobox(map, marker) {
    let height = $('.infoBox__wrap').height()
    height = height / 2

    map.setCenter(marker.position)
    map.panBy(0, -Math.abs(height))
  }

  // Extra bottom padding pulls the fitted bounds toward the top of the map
  // so southern clusters (Vancouver Island, Okanagan) aren't crowded against
  // the bottom edge / zoom controls.
  function sm_boundsPadding() {
    return { top: 60, right: 60, bottom: 160, left: 60 }
  }

  sm_initMap()

  // Show all campuses of a institutions click events
  let triggerEvent = true
  $(document).on('mouseover', '.js-institution', function (e) {
    let id = $(this).data('institution-id')
    $.each(allMarkers, function (index, marker) {
      if (marker.isMainCampus && marker.institutionId == id && marker.content) {
        marker.content.classList.add('a-institution-marker--active')
        triggerEvent = false
      }
    })
  })

  $(document).on('mouseleave', '.js-institution', function (e) {
    triggerEvent = true
    $.each(allMarkers, function (index, marker) {
      if (marker.content) {
        marker.content.classList.remove('a-institution-marker--active')
      }
    })
  })

  $('.js-institution').on('click', function () {
    let id = $(this).data('institution-id')

    if (window.matchMedia('(max-width: 1049px)').matches) {
      $('html, body').animate(
        { scrollTop: $('#js-institutions-map').offset().top - 50 },
        500,
        sm_showInstitutionCampuses(id),
      )
    } else {
      sm_showInstitutionCampuses(id)
    }
  })

  // Delegated so it keeps working as the InfoWindow content is re-created on each open
  $(document).on('click', '.js-show-all-campuses', function (e) {
    e.preventDefault()
    let id = $(this).data('institution-id')
    sm_showInstitutionCampuses(id)
  })

  // Custom close "x" lives inside .infoBox__wrap so it can be styled/scoped
  // with the rest of the popup content (Google's native close button is
  // rendered outside .infoBox__wrap and is hidden via CSS instead).
  $(document).on('click', '.js-infobox-close', function (e) {
    e.preventDefault()
    if (infoWindow) {
      infoWindow.close()
    }
  })

  // Show All Institutions of a region
  $('.js-show-regional-institution').on('change', function () {
    let region = $(this).find(':selected').val()

    if (region === 'all') {
      $('.js-institution').show()
    } else {
      $('.js-institution[data-region-id!="' + region + '"]').hide()
      $('.js-institution[data-region-id="' + region + '"]').show()
    }

    if (window.matchMedia('(max-width: 1049px)').matches) {
      $('html, body').animate(
        { scrollTop: $('#js-institutions-map').offset().top - 50 },
        500,
        sm_showRegionInstitution(region),
      )
    } else {
      sm_showRegionInstitution(region)
    }
  })
})
